import React from 'react'
import { ITreeElementProps } from 'helpers/types/tree'

export const FilterTitle: React.FC<ITreeElementProps> = ({ props, appliedFilterClassName }) => {
    return (
        <span className={`${props.item.type} ${appliedFilterClassName} `}>
            {props.item.name}
        </span>
    )
}